import React, { PureComponent } from 'react';

export default class MetaData extends PureComponent {
    render() {
        var { data } = this.props;
        data = {
            '@context': 'http://schema.org',
            ...data,
        };
        return (
            <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: JSON.stringify( data ) } } />
        );
    }
}
